import React, { useState, useEffect } from "react";
import "../Services/Services.css";
import CharIcon from "../../Assets/img/word.png";
import UploadIcon from "../../Assets/img/upload.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useNavigate } from "react-router-dom";
import API from "../Service/Baseservice";
import { useLocation } from "react-router-dom";
import TestimonialReviewPreview from "./TestimonialReviewPreview";
const TestimonialReviewAdd = () => {
    const navigate = useNavigate();

    // STATE VARIABLES
    const [ratingList, setRatingList] = useState([]);

    const [name, setName] = useState("");
    const [professional, setProfessional] = useState("");
    const [rating, setRating] = useState("");
    const [description, setDescription] = useState("");
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const langFromURL = searchParams.get("lang");
    const testimonialIdFromState = location.state?.testimonial_id;

    const [languageId, setLanguageId] = useState(parseInt(langFromURL) || 1);
    const [testimonialId, setTestimonialId] = useState(
        parseInt(testimonialIdFromState) || null
    );

    const [imagePreview, setImagePreview] = useState("");
    const [imageFile, setImageFile] = useState(null);
    const [uploadedUrl, setUploadedUrl] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPreviewTestimonialReview, setShowPreviewTestimonialReview] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });

    const showPopup = (title, message, type = "error") => {
        setPopup({ show: true, title, message, type });
    };

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return (div.textContent || div.innerText || "").length;
    };

    useEffect(() => {
        API.post("/rating_list/condition", { language_id: languageId })
            .then((res) => {
                const list = res.data?.data?.data;
                if (Array.isArray(list)) setRatingList(list);
            })
            .catch(() => console.log("Rating list fetch failed"));
    }, [languageId]);


    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setImageFile(file);

        const reader = new FileReader();
        reader.onloadend = () => setImagePreview(reader.result);
        reader.readAsDataURL(file);
    };

    const handleSubmit = () => {
        if (!name.trim()) return showPopup("Validation Error", "Please enter name.");
        if (!professional.trim()) return showPopup("Validation Error", "Please enter profession.");
        if (!rating) return showPopup("Validation Error", "Please select a rating.");
        if (!description || getPlainTextLength(description) === 0)
            return showPopup("Validation Error", "Please enter description.");
        if (!imageFile) return showPopup("Validation Error", "Please upload an image.");

        setIsSubmitting(true);
    };


    useEffect(() => {
        if (isSubmitting && imageFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result;
                const imagePayload = {
                    name: imageFile.name,
                    image: [
                        {
                            name: imageFile.name,
                            type: imageFile.type,
                            size: `${imageFile.size} bytes`,
                            base64: base64Image,
                        },
                    ],
                };

                API.post("/imageUpload/add", imagePayload)
                    .then((res) => {
                        if (res.data.success) {
                            setUploadedUrl(res.data.url);
                        } else {
                            throw new Error("Image upload failed");
                        }
                    })
                    .catch((err) => {
                        console.error("Image upload failed:", err);
                        showPopup("Error", "Image upload failed", "error");
                        setIsSubmitting(false);
                    });
            };
            reader.readAsDataURL(imageFile);
        }
    }, [isSubmitting, imageFile]);


    useEffect(() => {
        if (uploadedUrl && isSubmitting) {
            const finalPayload = {
                language_id: languageId,
                testimonial_id: parseInt(testimonialId),
                name,
                imageupload: uploadedUrl,
                professional,
                description,
                rating: parseInt(rating),
                createdBy: 1,
                updatedBy: 1,
            };


            API.post("/add_videoreview/add", finalPayload)
                .then((res) => {
                    if (res.data.success) {
                        showPopup("Success", "Video review added successfully!", "success");

                        const id = testimonialId || 1;
                        setTimeout(() => navigate(`/testimonialedit/${id}?lang=${languageId}`), 1000);
                    } else {
                        showPopup("Failed", "Failed to add review. Try again.", "error");
                    }
                })
                .catch((err) => {
                    console.error("Failed to add review:", err);
                    showPopup("Error", "Error connecting to server.", "error");
                })
                .finally(() => setIsSubmitting(false));
        }
    }, [uploadedUrl, isSubmitting]);
    if (testimonialId === null) {
        return (
            <div style={{ padding: "20px", fontSize: "18px" }}>
                <b>Error:</b> Testimonial ID not received.<br />
                Please open this page through the “Add Review Testimonial” button.
            </div>
        );
    }

    const handlePreview = () => {
        if (!name.trim() || !professional.trim() || !rating || !description) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Please fill all required fields",
                type: "info",
            });
        }

        const previewReview = {
            review_id: "preview",
            name,
            professional,
            rating,
            description,
            imageupload: imagePreview,
        };

        Promise.all([
            API.post("testimoniallistview/condition", {
                language_id: 1,
                home_id: 2,
                testimonial_id: testimonialId,
            }),
            API.post("testimoniallistview/condition", {
                language_id: 2,
                home_id: 4,
                testimonial_id: testimonialId,
            }),
        ])
            .then(([res1, res2]) => {
                const reviews1 = res1.data?.data?.video_reviews || [];
                const reviews2 = res2.data?.data?.video_reviews || [];

                const allReviews = [previewReview, ...reviews1, ...reviews2];

                setPreviewData(allReviews);
                setShowPreviewTestimonialReview(true);
            })
            .catch(() => {
                setPreviewData([previewReview]);
                setShowPreviewTestimonialReview(true);
            });
    };



    return (
        <div className="newss-containeradd">
            <div className="service-header-bar">
                <h2>Add Video Review</h2>
                <div className="button-group">
                    <button onClick={handlePreview} className="language-save-btn">
                        Preview
                    </button>
                    <button className="language-save-btn" onClick={handleSubmit}>Save</button>
                    <button
                        onClick={() => navigate(`/testimonialedit/${testimonialId}?lang=${languageId}`)
                        }
                        className="language-cancel-btn"
                    >
                        Back
                    </button>

                </div>
            </div>

            <div className="service-container">
                {/* LEFT SECTION */}
                <div className="left-form">
                    <div className="upload-section">
                        <label>Upload Image<span style={{ color: "red" }}>*</span></label>
                        <div className="service-upload-box">
                            {imagePreview ? (
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    className="preview-img"
                                />
                            ) : (
                                <>
                                    <img src={UploadIcon} alt="Upload" className="upload-icon" />
                                    <p>Click to upload</p>
                                </>
                            )}
                            <input type="file" accept="image/*" onChange={handleImageUpload} />
                        </div>
                    </div>
                </div>

                {/* RIGHT SECTION */}
                <div className="testimonial-right-section">
                    <div className="form-group">
                        <label>Name <span className="required">*</span></label>
                        <input
                            type="text"
                            maxLength={70}
                            placeholder="Enter name..."
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label>Professional <span className="required">*</span></label>
                        <input
                            type="text"
                            maxLength={150}
                            placeholder="Enter profession..."
                            value={professional}
                            onChange={(e) => setProfessional(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label>Rating <span className="required">*</span></label>
                        <select
                            className="input-field"
                            value={rating}
                            onChange={(e) => setRating(parseInt(e.target.value))}
                        >
                            <option value="">Select Rating</option>
                            {ratingList.map((r) => (
                                <option key={r.rating_id} value={parseFloat(r.rating)}>{r.rating}</option>
                            ))}
                        </select>
                    </div>

                    <div className="news-form-group review-editor-small">
                        <label >
                            <span>Description <span className="required">*</span></span>
                        </label>

                        <CKEditor
                            editor={ClassicEditor}
                            data={description}
                            onChange={(event, editor) => {
                                const html = editor.getData();
                                if (getPlainTextLength(html) <= 4000) setDescription(html);
                            }}
                            config={{
                                toolbar: [
                                    "undo", "redo", "|",
                                    "heading", "|",
                                    "bold", "italic", "underline", "|",
                                    "bulletedList", "numberedList"
                                ]
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* POPUP */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            <button className="btn ok-btn" onClick={() => setPopup({ ...popup, show: false })}>OK</button>
                        </div>
                    </div>
                </div>
            )}
            {showPreviewTestimonialReview && (
                <TestimonialReviewPreview
                    previewService={previewData}
                    setShowPreviewTestimonialReview={setShowPreviewTestimonialReview}
                />
            )}
        </div>
    );
};

export default TestimonialReviewAdd;
